import styled from 'styled-components';

export const ButtonToTop = styled.a`
  position: fixed;
  display: flex;
  right: 50px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  background-color: #edbd2f;
  border-radius: 5px;
  &:hover {
    background-color: rgb(170, 141, 25);
  }
  i {
    font-size: 30px;
    margin: 10px auto;
  }
`

export const MainMenu = styled.ul`
  margin-top: 20px;
  li {
    font-size: 22px;
    font-weight: bold;
    padding: 5px 0;
  }
  a {
    color: #fff;
  }
`
export const InstructionList = styled.ul`
    img{
      max-width: 100%;
      padding: 0 5px;
    }
`;

export const InstructionItemContent = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  ul {
    padding-top: 10px;
    line-height: 1.2;
  }
  span {
    font-size: 16px;
    margin-bottom: 40px;
    color: #edbd2f;
}
  img {
    align-self: center;
  }
`;

export const InstructionItem = styled.li`
  margin-top: 50px;
  border-bottom: 2px solid #fff;
  @media (max-width: 600px){
    line-height: 1.2;
  }

  ul > li {
    font-size: 16px;
  }
  h2, h3, h4, p {
    margin-top: 10px;
  }
  h2{
    text-align: left;
  }
  h3 {
    font-size: 25px;
    font-weight: bold;
  }
  p{
    margin-bottom: 10px;
    font-size: 16px;
  }
`
export const InstructionItemHeader = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #edbd2f;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    background-color: #edbd2f;
    text-align: center;
    font-weight: bold;
    color: #000;
    width: 20px;
    height: 20px;
    border-radius: 5px;
    box-shadow: 3px 3px 3px 0 rgba(0,0,0,0.75);
  }
  h3 {
    margin-bottom: 10px;
  }
`



// WEBPACK FOOTER //
// ./src/system/main/habitants/components.js